<template>
  <div id="LikeCount" :style="{'color': liked?'#1baaf1':'#8a94a2'}" @click="toggleLike">
    <span class="icon">
      <img src="@/assets/icon/like-active.svg" v-if="liked">
      <img src="@/assets/icon/like.svg" v-else>
    </span>
    <span class="number" v-if="question">
      <ICountUp :endVal="question.count_likes || 0"/>
    </span>
    <span class="number" v-if="answer">
      <ICountUp :endVal="answer.count_likes || 0"/>
    </span>
  </div>
</template>

<script>
// Apis Section
import talksApi from '@/api/now/talksApi'

// Variable Section

export default {
  name: 'LikeCount',
  props: ['question', 'answer'],
  data: function () {
    return {
    }
  },
  computed: {
    liked() {
      if (this.question) return this.question.like
      if (this.answer) return this.answer.like
      return false
    }
  },
  created() {
  },
  destroyed() {},
  methods: {
    async toggleLike() {
      if (this.answer) {
        if (!this.answer.like) {
          let { data } = await talksApi.likeAnswer(this.answer)
          this.answer.like = data.like
          this.answer.count_likes = data.count_likes
        } else {
          let { data } = await talksApi.unlikeAnswer(this.answer)
          this.answer.like = data.like
          this.answer.count_likes = data.count_likes
        }
      } else if (this.question) {
        if (!this.question.like) {
          let { data } = await talksApi.likeQuestion(this.question)
          this.question = data
          this.question.like = data.like
          this.question.count_likes = data.count_likes
        } else {
          let { data } = await talksApi.unlikeQuestion(this.question)
          this.question.like = data.like
          this.question.count_likes = data.count_likes
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  #LikeCount {
    span {
      display: block;
      float: left;
      &.number {
        font-weight: 700;
        margin-left: 6px;
      }
    }
  }
</style>
